import type { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { isLocationPageType } from '@/domain/useCases/pageTypeCheck'
import type { PageType } from '@/types/models'

export const generateReviewSectionTitle = ({
  pageType,
  title,
  primaryFocus
}: {
  pageType: PageType
  title: string
  primaryFocus: PrimaryFocus
}): string => {
  if (isLocationPageType(pageType)) {
    return `Reviews for Rehabs in ${title}`
  }

  return `Highlighted Reviews`
}
